import { RescheduleBookingEndpoint } from '@kouto/types';

import ApiResponse from 'api/types/ApiResponse';
import { z } from 'zod';
import { post } from '../api';

type RescheduleBookingRequest = z.infer<
  typeof RescheduleBookingEndpoint.requestSchema
>;

export const rescheduleBooking = async (
  bookingId: string,
  brandId: string,
  body: RescheduleBookingRequest,
) => {
  const url = RescheduleBookingEndpoint.url({
    bookingId,
  });

  return post<ApiResponse<{ data: void }>>(
    `${process.env.KOUTO_API_URL}/${url}`,
    {
      body: JSON.stringify(body),
      headers: {
        'Kouto-Brand-Id': brandId,
        'Way-Brand-Id': brandId,
      },
    },
  );
};
